import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=6a79c671&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=6a79c671&prod&scoped=true&lang=css&external"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=6a79c671&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a79c671",
  null
  
)

export default component.exports